<template>
    <div class="container">
        <h1>Configure Boards</h1>
        <b-tabs position="is-centered" class="block" v-model="activeTab">
            <b-tab-item label="List">
                <b-table
                        v-if="boards.length > 0"
                        :striped="true"
                        :narrowed="true"
                        :data="boards"
                        default-sort="prio"
                        default-sort-direction="desc"
                >
                    <template slot-scope="props">
                        <b-table-column label="Board" field="name">
                            <router-link :to="{path: '/configure/boards/' + props.row.id}">{{props.row.name}}</router-link>
                        </b-table-column>
                        <b-table-column label="Groups" numeric>{{props.row.items.length}}</b-table-column>
                        <b-table-column label="Prio" field="prio" numeric sortable>{{props.row.prio}}</b-table-column>
                    </template>
                </b-table>
            </b-tab-item>
            <b-tab-item label="Add Board">
                <div class="container has-text-left margin_top_1rem">
                    <b-field label="Name">
                        <b-input v-model="name" required placeholder="Enter name for the board"></b-input>
                    </b-field>
                    <b-field label="Prio">
                        <b-numberinput v-model="prio" min="0" step="1"></b-numberinput>
                    </b-field>
                    <div class="buttons">
                        <b-button type="is-success" :disabled="!validFields()" @click="handleAddBoard">Create</b-button>
                    </div>
                </div>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import BTable from "buefy/src/components/table/Table";
    import BTableColumn from "buefy/src/components/table/TableColumn";
    import BField from "buefy/src/components/field/Field";
    import BButton from "buefy/src/components/button/Button";
    import BNumberinput from "buefy/src/components/numberinput/Numberinput";

  export default {
    name: "screenconfigureboards",
    components: {
      BNumberinput,
      BButton,
      BField,
      BTableColumn,
      BTable
    },
    data() {
      return {
        activeTab: 0,
        name: '',
        prio: 5
      };
    },
    computed: {
      ...mapGetters('objects', ['boards'])
    },
    methods: {
      ...mapActions('objects', ['addBoard']),
      validFields() {
        if (!this.name || this.name.length < 1) {
          return false;
        }
        return true;
      },
      resetFields() {
        this.name = '';
        this.prio = 5;
      },
      handleAddBoard() {
        this.addBoard({
          name: this.name,
          prio: this.prio
        });
        this.resetFields();
        this.activeTab = 0;
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>
h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
}

    .margin_top_1rem {
        margin-top: 1rem;
    }
</style>